import React from 'react';
import { Card, Form, Col, Row } from '@deere/ux.uxframe-react';
import Button from '@material-ui/core/Button';
import { getKey } from '../GenerateKey';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import styles from '../DealerMerge/index.css';
import { SpinnerIcon, SuccessIcon } from '../Icon';
import {messages} from './messages';
import { DeereFetch } from '../../shared/fetch';

export class DealerMerge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sourceDealers: [],
            newDealer: '',
            validationError: [],
            confirmationDialog: false,
            processing: false,
            mergeResult: '',
            mergeApiError: null
        }
        this.getSourceDealers = this.getSourceDealers.bind(this);
        this.getNewDealer = this.getNewDealer.bind(this);
        this.validateMerge = this.validateMerge.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.mergeDealers = this.mergeDealers.bind(this);
        this.clearAll = this.clearAll.bind(this);
    }

    async mergeDealers(e) {
        e.preventDefault();

        this.setState({ processing: true });
        const sourceDealers = this.state.sourceDealers;
        const newDealer = this.state.newDealer;

        this.setState({ confirmationDialog: false }); // Close merge popup

        const body = {
            'oldThirdPartyNumbers': sourceDealers,
            'newThirdPartyNumber': newDealer
        }

        try {
            const mergeResponse = await DeereFetch('/api/merger/merger-and-acquisition', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            });

            this.setState({
                mergeResult: mergeResponse,
                mergeApiError: mergeResponse === false ? messages.genericError : null,
                processing: false
            });

        } catch (err) {

            this.setState({
                processing: false
            });

            this.setState({
                mergeApiError: `An error occured: ${err.status} ${err.error} ${err.message}`
            });
        }
    }

    handleClose = (e) => {
        e.preventDefault();
        this.setState({
            confirmationDialog: false
        })
    };

    clearAll = (e) => {
        e.preventDefault();
        window.location.reload();
    };


    getSourceDealers(source) {
        const removeSpaces = source.replace(/\s+/g, '');
        const filteredList = removeSpaces.toUpperCase().split(';').filter(value => value !== '' && value !== null);
        this.setState({
            sourceDealers:filteredList
        });
    }

    getNewDealer = (newDealer) => {
        this.setState({
            newDealer: newDealer.toUpperCase()
        });

    }

    validateMerge = (e) => {
        e.preventDefault();
        this.setState({mergeResult: ''});
        const errors = [];
        this.state.sourceDealers.length < 1 && errors.push(messages.error1);
        this.state.newDealer.length !== 10 && errors.push(messages.error2);
        this.state.sourceDealers.includes(this.state.newDealer) && errors.push(messages.error3);
        this.setState({ validationError: errors });
        {
            errors.length === 0 &&
                this.setState({
                    confirmationDialog: true
                })
        }
    }

    render() {
        return (
            <div className={this.state.processing ? `${styles.isDisabled}` : 'mNaDiv'}>
                <h3 className="mb10">Merger & Acquisition </h3>
                <Card >
                    <Card.Body>
                        <Row>
                            <div className={`${styles.prerequisitesInfo}`}>
                                <span className="d-block font-weight-bold mb-2">Important prerequisites: </span>
                                {messages.importantInfo.map(info =>  <span className="d-block mb-1 pl-3" key={'info-'+ getKey()}>{info} </span>)}
                            </div>
                        </Row>
                        <Row>
                            <Col >
                                <Form id="mNaForm">
                                    <Form.Group controlId="formGridName">
                                        <Form.Label className="uxf-label">
                                            Source Dealer Ids{' '}
                                            <span aria-label="required field" className="uxf-is-required">*</span>
                                        </Form.Label>
                                        <Form.Control className="text-uppercase" onChange={e => this.getSourceDealers(e.target.value)}
                                            placeholder="TALF000001;TALF000002" required type="text" />
                                        <small className="form-text text-muted" id="sourceDealerHelp">
                                            Enter semicolon seperated values
                                        </small>
                                    </Form.Group>
                                    <br />
                                    <Form.Group controlId="formGridEmail">
                                        <Form.Label className="uxf-label">
                                            New Dealer Id{' '}
                                            <span aria-label="required field" className="uxf-is-required">*</span>
                                        </Form.Label>
                                        <Form.Control className="text-uppercase" onChange={e => this.getNewDealer(e.target.value)} placeholder="TALF000333" required
                                            type="text" />
                                        <small className="form-text text-muted" id="sourceDealerHelp">
                                            Only one value expected
                                        </small>
                                    </Form.Group>
                                    <br />
                                    <Button color="primary" onClick={e => this.validateMerge(e)} size="medium"
                                        variant="contained">Review</Button>
                                    <Button className="ml-2" color="inherit" onClick={e => this.clearAll(e)} size="medium"
                                        variant="contained">Clear</Button>
                                </Form>
                            </Col>

                            <Col>
                                <div className="d-flex flex-column align-items-left">
                                    {this.state.validationError.map(err =>
                                        <p className={`text-danger p-2 ${styles.validationError}`} key={'err-' + getKey()}
                                            style={{ fontSize: 13 }}><strong>Error:</strong> {err}</p>
                                    )}
                                </div>
                                {this.state.processing
                                    && <div className={'d-flex flex-column align-items-center'}>
                                        <p className="font-weight-bold text-success">Please wait...</p>
                                        <p className="text-success">{messages.processingInfoText}</p>
                                        <SpinnerIcon size="md" />
                                    </div>}
                                {this.state.mergeApiError !== null &&
                                <p className={`${styles.mergeFailed}`}>{this.state.mergeApiError}</p>
                                }

                                {this.state.mergeResult &&
                                <div>
                                    <p className={`${styles.mergeSuccess}`}>
                                        <SuccessIcon className="mergesuccess" size="18%"/>
                                        <span className="d-block mt-20"> {messages.mergeSuccessText}</span></p>
                                </div>
                                }

                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Dialog aria-labelledby="customized-dialog-title" fullWidth={true}
                    onClose={e => this.handleClose(e)}
                    open={this.state.confirmationDialog}>
                    <Row className="d-flex ml-3 mr-2 mt-2 justify-content-between">
                        <span className="d-inline">
                            <h5 className="font-weight-bold mt-1">Review Details</h5>
                        </span>
                        <span className="d-inline">
                            <IconButton aria-label="close" onClick={e => this.handleClose(e)} size="small">
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Row>
                    <Divider />
                    <DialogContent >
                        <div className={styles.warningText}>
                            <p className="ml-3 pt-2 pb-2 font-weight-bold">{messages.warningText}</p>
                        </div>
                        <p className="mt-2">{messages.infoText}</p>

                        <Row>
                            <Col>
                                <dl className="uxf-dl">
                                    <dt>Source Dealer Ids:</dt>
                                    {this.state.sourceDealers.map(srcDealer =>
                                        <dd key={'sd-' + getKey()}>{srcDealer}</dd>
                                    )}
                                </dl>
                            </Col>
                            <Col>
                                <dl>
                                    <dt>New Dealer Id:</dt>
                                    <dd>{this.state.newDealer}</dd>
                                    <br />
                                </dl>
                            </Col>
                            <br />
                        </Row>
                    </DialogContent>

                    <Divider />

                    <DialogActions>
                        <Button className="mt-1 mb-1" color="primary" onClick={e => this.mergeDealers(e)}
                            size="medium" variant="contained" >Merge</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

}
